import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { alertStyling, alertIconStyling } from './styling';
import { cn } from '../../utils';
import { WarningIcon } from '../../icons';
import { ElementIntent } from '../../enums';
const getIcon = (intent) => {
    switch (intent) {
        case ElementIntent.Info:
            return _jsx(WarningIcon, {});
        case ElementIntent.Warning:
            return _jsx(WarningIcon, {});
        case ElementIntent.Danger:
            return _jsx(WarningIcon, {});
        case ElementIntent.Success:
            return _jsx(WarningIcon, {});
        default:
            return _jsx(WarningIcon, {});
    }
};
function AlertHeading({ children, className }) {
    return (_jsx("h5", { className: cn('text-gray-800 font-medium', className), children: children }));
}
function AlertBody({ children, className }) {
    return (_jsx("div", { className: cn('text-gray-700 font-light', className), children: children }));
}
export function Alert({ intent = ElementIntent.Info, children, className, }) {
    return (_jsxs("div", { className: cn(alertStyling({ intent }), className), children: [_jsx("div", { className: alertIconStyling({ intent }), children: getIcon(intent) }), _jsx("div", { className: "flex-1", children: children })] }));
}
Alert.Heading = AlertHeading;
Alert.Body = AlertBody;
